import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ChangeControlLibraryRoutingModule } from './change-control-library-routing.module';
import { ChangeControlSliderComponent } from './components/change-control-slider/change-control-slider.component';
import { ChangeControlLibraryComponent } from './components/change-control-library/change-control-library.component';
import { ChangeControlGeneralDetailsComponent } from './components/change-control-general-details/change-control-general-details.component';
import { TabViewModule } from 'primeng/tabview';
import { FieldsetModule } from 'primeng/fieldset';
import { PanelModule } from 'primeng/panel';
import { SharedModule } from '../../shared/shared.module';
import { DialogModule } from 'primeng/dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ToastModule } from 'primeng/toast';
import { MessageModule } from 'primeng/message';
import { MessagesModule } from 'primeng/messages';
import { CalendarModule } from 'primeng/calendar';
import { BptProgressSpinnerModule } from 'bpt-ui-library/bpt-progress-spinner';
import { BptSearchModule } from 'bpt-ui-library/bpt-search';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { BptDateTimeModule } from 'bpt-ui-library/bpt-datetime';
import { BptDropdownModule } from 'bpt-ui-library/bpt-dropdown';
import { BptTagsModule } from 'bpt-ui-library/bpt-tags';
import { BptTextInputModule } from 'bpt-ui-library/bpt-text-input';
import { BptNumericInputModule } from 'bpt-ui-library/bpt-numeric-input';
import { CheckboxModule } from 'primeng/checkbox';
import { ChangeControlCatalogueModule } from '../../change-control-catalogue/change-control-catalogue.module';
import { ChangeControlRelatedDocumentsComponent } from './components/change-control-related-documents/change-control-related-documents.component';
import { RelatedDocumentsComponent } from '../../shared-components/related-documents/related-documents.component';

import { BptFileUploadModule } from 'bpt-ui-library/bpt-file-upload';
import { ChangeControlFilesComponent } from './components/change-control-files/change-control-files.component';
import { SpinnerComponent } from "../../shared-components/spinner/spinner.component";
@NgModule({
  declarations: [
    ChangeControlLibraryComponent,
    ChangeControlSliderComponent,
    ChangeControlGeneralDetailsComponent,
    ChangeControlFilesComponent,
    ChangeControlRelatedDocumentsComponent
  ],
  imports: [
    CommonModule,
    ChangeControlLibraryRoutingModule,
    TabViewModule,
    FieldsetModule,
    PanelModule,
    CheckboxModule,
    SharedModule,
    ToastModule,
    MessageModule,
    MessagesModule,
    DialogModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    ConfirmDialogModule,
    CalendarModule,
    BptProgressSpinnerModule,
    BptDateTimeModule,
    BptTextInputModule,
    BptNumericInputModule,
    BptTagsModule,
    BptDropdownModule,
    BptSearchModule,
    ChangeControlCatalogueModule,
    RelatedDocumentsComponent,
    BptFileUploadModule,
    SpinnerComponent
],
  exports: [ChangeControlSliderComponent]
})
export class ChangeControlLibraryModule {}
